import React, { useEffect, useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar.js";
import Select from "react-select";

import { connect } from "react-redux";
import { gain_request } from "../../../store/acion";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import { async } from "@firebase/util";
import { useNavigate, useLocation } from "react-router-dom";
import {
  doc,
  setDoc,
  collection,
  getFirestore,
  waitForPendingWrites,
  updateDoc,
  onSnapshot,
  query,
  where
} from "firebase/firestore";

function Sheduled(props) {
  const navigate = useNavigate();

  const [data_gain, setdata_gain] = useState(false);
  const [request_data, setrequest_data] = useState([]);

  // useEffect(() => {
  //   if (props.request != "fail") {
  //     console.log("sdsadas", props.request);

  //     let arr = props.request.filter(
  //       (e) => e.uid == localStorage.getItem("user_uid")
  //     );
  //     setrequest_data(arr);
  //   }
  // }, [data_gain]);








  useEffect(()=>{
 
   
   

   
    
    const db=getFirestore()
      onSnapshot(query(collection(db, "request"), where("uid", "==", localStorage.getItem("user_uid"))), (querySnapshot) => {


        let arr=[]
        querySnapshot.forEach( async (docs) => {
          
             

         arr.unshift(docs.data())
          });

     
         setrequest_data(arr);
        
         setdata_gain(true);



    });
},[])



  
  const re_load = async () => {
    if (props.request == "fail") {
      setdata_gain(false);
      await props.gain_request();
      console.log("fail>>>>>.");
    } else {
      // console.log("yes>>>>>.", props.request);
     
        


      // setrequest_data(arr)
    }
  };

  useEffect(() => {
    re_load();
  });

  return localStorage.getItem("user_uid") !== null ? (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <Navbar />
        {/* Header */}
        <div className="relative bg-pink-600 md:pt-12 pb-10">
          <div className="px-4 md:px-10 mx-auto w-full ml-2 d-flex align-items-center justify-content-center flex-column">
            <div style={{ height: 38 }}></div>
            <div className="d-flex align-items-center flex-column pb-9">
              <h1 className="text-white font-semibold text-3xl	 text-center">
                Sheduled History
              </h1>
            </div>
          </div>
        </div>

        {data_gain ? (
          <table>
            <thead>
              <tr className="tr">
                <th scope="col">Sr#</th>
                <th scope="col">Date</th>
                <th scope="col">Teacher Name</th>
                <th scope="col">Teacher Email</th>
                <th scope="col">Meeting Date</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {request_data?.map((v, i) => {
                return (
                  <tr className="tr">
                    <td data-label="Sr#" >{i}</td>
                    <td data-label="Date">{v.date}</td>
                    <td data-label="Teacher Name">{v.teacher_name}</td>
                    {/* <td data-label="Teacher Email">
                      <p>{v.teacher_email}</p>
                    </td> */}
                    <td data-label="Meeting Date">{v.meeting_date}</td>
                    <td data-label="Action" className="tdw10" style={{height:50}}>
                      {v.meeting_date != "Meeting End" ? (
                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            if (v.join_url) {
                              let url =
                                v.join_url.replaceAll(
                                  "https://us04web.zoom.us/j/",
                                  "http://localhost:9996/?"
                                ) + `?role=2?name=${v.name}`;
                              window.open(url);
                            } else {
                              alert("Meeting is not started");
                            }
                          }}
                        >
                          Join meeting
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div class="loading" id="loading">
            Loading&#8230;
          </div>
        )}
      </div>
    </>
  ) : (
    navigate("/Login")
  );
}

const mapStateToProps = (state) => {
  return {
    request: state.request,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain_request: () => dispatch(gain_request()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Sheduled);
